import { PayloadHistoryMyBetTXCB } from 'models/txcb-model';
import { useEffect, useRef, useState } from 'react';
import './hisbet.scss';
import { WstxcbService } from 'apis/wstxcb';
import { convertMoneyTxt, getDateTimeDD_MM_YYYY, getDateTimeHH_MM_SS } from 'utils/time-utils';
import { environment } from 'environments/environment';
import { PayloadSearchBetRecord } from 'models/commonModel';
import moment from 'moment';
import { BetRecordDetailResponse } from 'models/lotteryModel';
import rongHoApi from 'apis/rongho-api';
import userApi from 'apis/userApi';
import toast from 'react-hot-toast';

interface listHisMini {
    taixiuId: string;
    typed: number;
    result: any;
    txtBet: string;
    betamount: number;
    refundamount: number;
    winamount: number;
    time: string;
    date: string;
}

interface Props {
    isShow: boolean;
    onClose: () => void;
}
export default function HistoryMyBetRongHo(props: Props) {
    const { isShow, onClose } = props;
    const [listHis, setListHis] = useState<BetRecordDetailResponse[]>([]);
    const [pagiNum, setPagiNum] = useState<number>(1);
    useEffect(() => {
        if (isShow) {
            getHistoryMyBet('btnSearch');
        }
    }, [isShow]);

    const getHistoryMyBet = async (action: 'btnSearch' | 'nextPage' | 'proPage', cb?: () => void) => {
        let payload: PayloadSearchBetRecord = {
            lotteryid: 401,
        };
        if (action === 'btnSearch') {
            const currentDate = new Date();
            const date = currentDate.setDate(currentDate.getDate() - 35);
            const starttime = `${moment(new Date(date)).format('YYYY-MM-DD')} 00:00:00`;
            payload.starttime = starttime;
        }

        try {
            const { data } = await userApi.lotteryRecordBean(action, payload);
            if (!data.msg) {
                setPagiNum(data.totalpage);
                setListHis(convertData(data.reslist));
                cb && cb();
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        }
    };


    const convertData = (data: any) => {
        data && data.map((item: any) => {
            item.amount = convertMoneyTxt(item.amount);
            item.refundamount = convertMoneyTxt(item.refundamount);
            item.bonus = convertMoneyTxt(item.bonus);
            item.time = '';
            const betTime = new Date(item['bettime'].replace(/-/g, '/'));
            item.time = getDateTimeHH_MM_SS(betTime);
            item.date = getDateTimeDD_MM_YYYY(betTime);
            return item;
        });
        return data;
    }

    const getDragonTigerResult = (winnumber: string[] | string): string => {
        const map: Record<string, number> = { A: 1, J: 11, Q: 12, K: 13 };
        const toVal = (c: string): number => map[c] || +c;
      
        // Nếu là mảng thì lấy phần tử đầu tiên
        const winStr = Array.isArray(winnumber) ? winnumber[0] : winnumber;
      
        const [d, t] = winStr
          .split(',')
          .map((card: string) => toVal(card.split('-')[0].toUpperCase()));
      
        return d > t ? 'Rồng' : d < t ? 'Hổ' : 'Hòa';
      }

    return (
        <>
            <div id="lscRH">
                <section className="lsp-txcb">
                    <div className="wrapper">
                        <div className="title">Lịch Sử Cược</div>
                        <div className="close" onClick={onClose}>
                            <img src={require(`assets/images/txcanban/statis/close.png`)} alt='' />
                        </div>
                        <div className="inner">
                            <div className="pagi">
                                <button className="btnPagi btnPagiPrev" onClick={() => getHistoryMyBet('proPage')}><img src={require(`assets/images/txcanban/statis/prev.png`)} alt=""/></button>
                                    <span>{pagiNum}</span>
                                <button className="btnPagi btnPagiNext" onClick={() => getHistoryMyBet('nextPage')}><img src={require(`assets/images/txcanban/statis/next.png`)} alt=""/></button>
                            </div>
                            <div className="tblScorllHorizontal">
                                <div className="innerTblScroll">
                                    <table className="tblTop">
                                        <thead>
                                            <tr>
                                                <th className="idP">Phiên</th>
                                                <th className="cuaP">Đặt</th>
                                                <th className="moneyB">Cược</th>
                                                <th className="moneyW">Thắng</th>
                                                <th className="timeP">Thời Gian</th>
                                                <th className="resP">Kết Quả</th>
                                                <th className="resP">Trạng Thái</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <div className="wrapTbl">
                                        <table className="tblBottomScroll">
                                            <tbody>
                                                {listHis.length <= 0 && <tr>
                                                    <td>Không có dữ liệu</td>
                                                </tr>}
                                                {listHis.length > 0 && listHis.map((item, idx) => (
                                                    <tr key={idx}>
                                                        <td className="idP"><div>{item.issue}</div></td>
                                                        <td className="cuaP">
                                                            {item.bettype === '1' && <div>Rồng</div>}
                                                            {item.bettype === '2' && <div>Hổ</div>}
                                                            {item.bettype === '3' && <div>Hòa</div>}
                                                        </td>
                                                        <td className="moneyB"><div>{item['amount']}</div></td>
                                                        <td className="moneyW"><div>{item.bonus}</div></td>
                                                        <td className="timeP"><div>{item.bettime}</div></td>
                                                        <td className="timeP" style={{ color: getDragonTigerResult(item.winnumber) === 'Rồng' ? '#f61f1f' : getDragonTigerResult(item.winnumber) === 'Hổ' ? '#f6cb1f' : '#ffffff' }}><div>{getDragonTigerResult(item.winnumber)}</div></td>
                                                        <td className="timeP" style={{ color: item.statusname === 'Trượt' ? '#f61f1f' : item.statusname === 'Trúng' ? '#1adf3e' : '#ffffff' }}><div>{item.statusname}</div></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        </>
    );
}